export default __webpack_public_path__ + "static/soehne-breit-kraftig-74d41e10e914cd6d8e1ac243e0198b19.woff2";